import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const PowerSavingSwitcherContainer = styled.div<React.CSSProperties>`
  position: absolute;
  left: ${1495 * Screen.widthRatio}px;
  top: ${40 * Screen.widthRatio}px;
`;

export default PowerSavingSwitcherContainer;
